import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectDataToExecuteInventory, selectDataPosition, selectIsThirdCount } from '../../InventorySelector'
import { actions } from '../../InventoryState'
import { ExecutingCount } from '../ExecutingCount/ExecutingCount'
import { TableInventoriesToExecute } from '../TableInventoriesToExecute/TableInventoriesToExecute'
import { UnlinkOperator } from '../UnlinkOperator/UnlinkOperator'
import * as S from './StartCounting.styles'

interface Props {
  inventoryToExecute: any
}

export const StartCounting = ({ inventoryToExecute }: Props) => {
  const dispatch = useDispatch()
  const position = useSelector(selectDataPosition)
  const { badge, floor, addressesTypes } = useSelector(selectDataToExecuteInventory)
  const isThirdCount = useSelector(selectIsThirdCount)

  const [clickStartPosition, setClickStartPosition] = useState(false)
  const [clickUnlinkOperator, setClickUnlinkOperator] = useState(false)
  const [clickTryAgain, setClickTryAgain] = useState(false)
  const [, setInitialState] = useState(false)

  const onClickStartPosition = () => {
    dispatch(actions.registerStartPosition({
      idPosition: position.idPosition,
      badge,
    }))
    setClickStartPosition(true)
  }

  const onClickGetPosition = () => {
    dispatch(actions.getPosition({
      badge,
      floor,
      addressesTypes,
      id: inventoryToExecute.id,
      isThirdCount,
    }))
    setClickTryAgain(true)
  }

  useEffect(() => {
    if (clickTryAgain) {
      setTimeout(() => {
        setClickTryAgain(false)
      }, 2500)
    }
  }, [clickTryAgain])

  const clearStates = () => {
    dispatch(actions.setGoToPosition(false))
    dispatch(actions.clearState())
  }

  if (clickStartPosition && position.positionAddress) return <ExecutingCount inventoryToExecute={inventoryToExecute} setClickStartPosition={setClickStartPosition} />

  if (clickUnlinkOperator) return <UnlinkOperator setClickUnlinkOperator={setClickUnlinkOperator} />

  if (!badge) return <TableInventoriesToExecute setInitialState={setInitialState} />

  return (
    <S.Wrapper>
      <h5>Vá para a posição</h5>
      {position.positionAddress ? position.positionAddress : 'Nenhuma posição disponível'}
      <S.ContainerButton>
        <S.CustomButton
          title='Cheguei'
          bgColor='confirm'
          hoverColor='confirmHover'
          letterColor='white'
          disabled={!position.positionAddress}
          onClick={() => onClickStartPosition()}
          data-testid='start-counting-button'
        />
        {!position.positionAddress && position.tryAgain === true && (
        <S.CustomButton
          title='Tentar novamente'
          bgColor='orange'
          hoverColor='lightOrange'
          letterColor='white'
          onClick={() => onClickGetPosition()}
          disabled={clickTryAgain}
        />
        )}
        <S.CustomButton
          title='Desvincular'
          bgColor='blue'
          hoverColor='darkBlueHover'
          letterColor='white'
          onClick={() => setClickUnlinkOperator(true)}
          disabled={!position.idPosition}
        />
        {!position.positionAddress && (
          <S.CustomButton
            title='Voltar'
            bgColor='blue'
            hoverColor='darkBlueHover'
            letterColor='white'
            onClick={() => clearStates()}
          />
        )}
      </S.ContainerButton>
    </S.Wrapper>
  )
}
